// extracted by mini-css-extract-plugin
module.exports = {"search":"selectCryptoTokens_search__TsChB","selectCryptoTokensContent":"selectCryptoTokens_selectCryptoTokensContent__2EHoi","token":"selectCryptoTokens_token__1JYO9"};